import { Model } from 'app/model/backendmodel';
import { Owned } from 'app/model/base/named';
import { Activity } from 'app/model/pipeline/activity';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { BlobSink } from 'app/model/pipeline/copysink/blob.copysink';
import { FileTypeSinkAdapter } from 'app/model/adapters/activities/copysink/file-type.sink.adapter';
import { CopySinkAdapter } from './copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(BlobSink),
    asynchronous: true,
    adapts: {
        type: '*',
        copyBehavior: '*',
        maxConcurrentConnections: '*',
        structure: '*'
    }
})
export class BlobSinkAdapter extends CopySinkAdapter<BlobSink, Model.BlobSink> {
    protected override async _toResource(model: BlobSink): Promise<Model.BlobSink> {
        const result: Model.BlobSink = {
            type: Metamodel.modelFor(BlobSink).name
        };
        FileTypeSinkAdapter.toSinkResource(model, result);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.BlobSink, owner: Activity): Promise<BlobSink> {
        const result = Owned.create<BlobSink>(Metamodel.modelFor(BlobSink), owner);
        FileTypeSinkAdapter.toSinkModel(resource, result);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        return result;
    }
}
